/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowElbowRight = createReactComponent("outline", "arrow-elbow-right", "IconArrowElbowRight", [["path", { "d": "M21 14v-6h-6", "key": "svg-0" }], ["path", { "d": "M21 8l-9 9l-9 -9", "key": "svg-1" }]]);

export { IconArrowElbowRight as default };
//# sourceMappingURL=IconArrowElbowRight.mjs.map
